<template>
  <div id="roadmap">
    <b-card no-body class="shadow mb-5 mt-2">
      <b-card-header header-tag="header" role="tab" class="bg-white mb-1 mt-1">
        <h5 class="m-0">
          <a
              @click="handleRoadmap"
              class="text-dark"
              href="javascript: void(0);"
          >
            <i class="mdi mdi-calendar-range text-primary mx-2"></i>AI Features coming soon to <strong>Sellerdesk.ai!</strong>
          </a>
          <a class="close-icon" @click="handleRoadmap" v-if="showRoadmap">
            <i class="fa fa-times-circle font-size-16 text-dark close-icon-in"></i>
          </a>
        </h5>
      </b-card-header>

      <b-collapse id="roadmap" visible v-model="showRoadmap">
        <b-card-body>
          <b-row>
            <b-col xl="4" lg="4" md="12" sm="12">
              <div class="mb-4 card shadow p-3 bg-light" style="height: 45em">
                <div class="py-2">
                  <div class="text-center">
                    <h4 class="mb-3 text-dark">
                <span class="badge badge-soft-secondary">
                  <i class="mdi mdi-feather"></i>
                  AI Review&Feedback Analysis
                </span>
                    </h4>
                  </div>
                </div>
                <div>
                  <b-card-img height="370px" :src="require('@/assets/images/roadmap/ai-text.svg')"></b-card-img>
                </div>
                <div class="text-center">
                  <p class="text-muted">
                    Keep track of your product reviews and seller feedback with in-depth reports of trends, AI text analyses
                    along with the helpful data insights to get to know your buyers better and take action on their needs.
                  </p>
                </div>
              </div>
            </b-col>
            <b-col xl="4" lg="4" md="12" sm="12">
              <div class="mb-4 card shadow p-3 bg-light" style="height: 45em">
                <div class="py-2">
                  <div class="text-center">
                    <h4 class="mb-3 text-dark">
                <span class="badge badge-soft-secondary">
                                    <i class="mdi mdi-feather"></i>
                  AI Product Search
                </span>
                    </h4>
                  </div>
                </div>
                <div>
                  <b-card-img height="370px" :src="require('@/assets/images/roadmap/search-img.svg')"></b-card-img>
                </div>
                <div class="text-center">
                  <p class="text-muted">
                    Need keywords for the item you sell or plan selling? AI Keyword Finder looks up on the Amazon for
                    similar products and find the most popular keywords for you to use, increasing the chances of your
                    item’s getting more views.
                  </p>
                </div>
              </div>
            </b-col>
            <b-col xl="4" lg="4" md="12" sm="12">
              <div class="mb-4 card shadow p-3 bg-light" style="height: 45em">
                <div class="py-2">
                  <div class="text-center">
                    <h4 class="mb-3 text-dark">
                <span class="badge badge-soft-secondary">
                                    <i class="mdi mdi-feather"></i>
                    AI Feedback Removal Request
                </span>
                    </h4>
                  </div>
                </div>
                <div>
                  <b-card-img height="370px" :src="require('@/assets/images/roadmap/feedback.svg')"></b-card-img>
                </div>
                <div class="text-center">
                  <p class="text-muted">
                    Yet another set-and-forget feature of our tool. It automates sending feedback removal requests for the
                    items according to the filters you choose.</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-card>

  </div>
</template>

<script>
import * as ls from 'local-storage'

export default {
  name: "Roadmap",
  data() {
    return {
      showRoadmap: false,
    }
  },
  methods: {
    handleRoadmap() {
      this.showRoadmap  = !this.showRoadmap
      ls.set('hideRoadmap', !this.showRoadmap)
    },
  },
  mounted() {
    if (!ls.get('hideRoadmap')) {
      this.showRoadmap = true
    } else {
      this.showRoadmap = false
    }
  }
}
</script>

<style scoped>
.close-icon {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
  margin-top: 3px;
}

.close-icon-in:hover {
  color: #7c7c7c !important;
}

.card-height {
  height: 370px !important;
}
</style>